import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { useTranslation } from "react-i18next";
import { PrimaryButton, SecondaryButton } from "@sprout/buttons";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
};

const DiscardProgressModal = ({ open, onOpenChange, onDiscard }: Props) => {
  const { t } = useTranslation("job_post");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            <span>{t("application.discard_modal.title")}</span>
          </DialogTitle>
        </DialogHeader>
        <DialogFooter>
          <SecondaryButton onClick={() => onOpenChange(false)}>
            {t("application.discard_modal.keep_editing")}
          </SecondaryButton>
          <PrimaryButton onClick={onDiscard}>{t("application.discard_modal.leave")}</PrimaryButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DiscardProgressModal;
